// payment/receipt.tsx
import React from 'react';
import { PaymentProps } from '../types';
import { usePayment } from '../hooks/usePayment';
import { ReceiptForm } from '../components/Form';
const PaymentPage: React.FC<Partial<PaymentProps>> = ({
  paidFrom = null,
  paidTo = null,
  onSaveComplete = () => null,
  method = 'CashPayment',
  type = 'payment',
}) => {
  const { formik } = usePayment({
    paidFrom,
    paidTo,
    onSaveComplete,
    method,
    type,
  });

  return (
    <div className="receipt">
      page here
      <ReceiptForm type="Payment" formik={formik} />
    </div>
  );
};

export { PaymentPage };
